<template>
	<div ref="selectRoot" class="delivery__group-input-wrapper">
		<div class="input">
			<label :id="labelId" :for="inputId" class="input__label">Вулиця</label>
			<v-select
				v-model="selectedAddress"
				:input-id="inputId"
				:options="addressOptions"
				label="label"
				:filterable="false"
				:clearable="false"
				@search="onSearch"
				@open="syncA11y"
				@close="syncA11y"
				@option:selected="onSelect"
				placeholder="Введи адресу"
			>
				<template #no-options="{ searching, search }">
					<span v-if="searching && search">Вибачте, немає відповідних варіантів</span>
					<span v-else>Почніть вводити адресу</span>
				</template>
			</v-select>
			<div class="input__error" aria-hidden="true"></div>
			<div :id="statusId" class="visually-hidden" aria-live="polite" aria-atomic="true">
				{{ selectedAnnouncement }}
			</div>
		</div>
	</div>
</template>

<script setup>
// @ts-nocheck
import { computed, nextTick, onMounted, ref, watch } from 'vue';
import { syncVueSelectA11y } from '../utils/vue-select-a11y';

const props = defineProps({
	inputId: {
		type: String,
		required: true
	},
	modelValue: {
		type: Object,
		default: null
	},
	city: {
		type: Object,
		default: null
	},
	invalid: {
		type: Boolean,
		default: false
	},
	errorId: {
		type: String,
		default: ''
	}
});

const emit = defineEmits(['update:modelValue']);

const addressOptions = ref(Array());
const selectedAddress = ref(props.modelValue || null);
const selectedAnnouncement = ref('');
const selectRoot = ref(null);

const labelId = computed(() => `${props.inputId}-label`);
const statusId = computed(() => `${props.inputId}-status`);

const syncA11y = () => {
	nextTick(() => {
		syncVueSelectA11y({
			root: selectRoot.value,
			labelId: labelId.value,
			statusId: statusId.value,
			hasSelectedValue: Boolean(selectedAddress.value?.label),
			invalid: props.invalid,
			errorId: props.errorId,
		});
	});
};

const announceSelected = (label = '') => {
	selectedAnnouncement.value = label ? `Обрано: ${label}` : '';
	syncA11y();
};

const resolveNpConf = () => {
	try {
		if (window['globalConf'] && window['globalNpConf']) {
			return window['globalConf'](window['globalNpConf']);
		}

		if (window['NpConf']) {
			return window['NpConf'];
		}
	} catch (error) {
		console.error('Failed to resolve NP config', error);
	}

	return null;
};

const onSearch = async (query = '') => {
	const term = (query || '').trim();
	if (term.length < 3) {
		addressOptions.value = [];
		return;
	}

	const npConf = resolveNpConf();
	const endpoint = npConf?.url?.getNpStreet;
	const shopName = npConf?.shop_name;
	const cityId = props.city?.city_id || sessionStorage.getItem('city_id');

	if (!endpoint || !shopName || !cityId) {
		addressOptions.value = [];
		return;
	}

	try {
		const response = await fetch(
			`${endpoint}?query=${encodeURIComponent(term)}&shop_name=${encodeURIComponent(shopName)}&city_id=${encodeURIComponent(cityId)}`
		);
		const data = await response.json();
		addressOptions.value = Array.isArray(data) ? data : [];
	} catch (error) {
		console.error('Failed to fetch streets', error);
		addressOptions.value = [];
	}
};

const onSelect = (item = null) => {
	if (!item) {
		return;
	}

	selectedAddress.value = item;
	emit('update:modelValue', item);
	announceSelected(item.label || '');

	sessionStorage.setItem('np_street', item.value || '');
	sessionStorage.setItem('address_label', item.label || '');
};

watch(() => props.modelValue, (value) => {
	selectedAddress.value = value || null;
	announceSelected(selectedAddress.value?.label || '');
});

watch(() => [props.invalid, props.errorId], syncA11y);

watch(() => props.city, () => {
	addressOptions.value = [];
	selectedAddress.value = null;
	emit('update:modelValue', null);
	announceSelected('');
	sessionStorage.setItem('np_street', '');
	sessionStorage.setItem('address_label', '');
});

onMounted(syncA11y);
</script>
